import { Box } from "@mui/system";
import { ReactElement } from "react";
import TransactionsDataGrid from "../hooks/transactions/transactionsDataGrid";

/**
 *
 * @returns {ReactElement} Nerd route
 */
export default function TransactionsRoute(): ReactElement {
  return (
    <Box sx={{ p: 1, display: "flex", flex: 1 }}>
      <TransactionsDataGrid />
    </Box>
  );
}
